import { FC, PropsWithChildren } from 'react'
import Box, { BoxProps } from '@mui/material/Box'
import { SxProps } from '@mui/material'

const Center: FC<
  PropsWithChildren<{ contentOverrides?: SxProps } & BoxProps>
> = ({
  maxWidth = 'lg',
  children,
  width = '100%',
  contentOverrides = {},
  ...otherBoxProps
}) => {
  return (
    <Box
      display={'flex'}
      justifyContent={'center'}
      {...otherBoxProps}
      width={'100%'}
    >
      <Box
        maxWidth={maxWidth}
        width={width}
        sx={{
          px: {
            xs: 2,
            sm: 2,
            md: 2,
            lg: 3,
            xl: 4,
          },
          py: 2,
          ...contentOverrides,
        }}
      >
        {children}
      </Box>
    </Box>
  )
}

export default Center
